import { ISbStoryData } from 'storyblok-js-client';

import {
  C2AAnalyticsClientProps,
  C2ACommonStoryblok,
  C2AFactsheetStoryblok,
  C2AMeetingStoryblok,
  C2APopupStoryblok,
  ExpertStoryblok,
  InvestmentProgramStoryblok,
  LinkStoryblok,
} from '@monoimin/sb-types';

import { C2ABlockDetails } from '../types';

import { getAnalyticsBlockName } from '.';

const blockVariantsMap: Record<string, string> = {
  default: 'Default',
  light: 'Light',
  large: 'Large',
  wide: 'Wide',
  price: 'Light',
  priceLarge: 'Large',
  priceBlack: 'Black',
};
function getBlockVariant(
  content:
    | C2AFactsheetStoryblok
    | C2AMeetingStoryblok
    | C2ACommonStoryblok
    | C2APopupStoryblok
): string {
  const variantFromMap = blockVariantsMap[content?.factsheetVariant];
  if (variantFromMap) {
    return variantFromMap;
  }
  return (
    content?.subVariant ||
    content?.factsheetVariant ||
    content?.meetingVariant ||
    ''
  );
}

function getBlockButtonText(
  content:
    | C2AFactsheetStoryblok
    | C2AMeetingStoryblok
    | C2ACommonStoryblok
    | C2APopupStoryblok
    | LinkStoryblok,
  block_button_text?: string,
  props?: C2ABlockDetails
): string {
  if (content.component === 'link') {
    return content.description ?? content.link?.['title'] ?? '';
  }

  return (
    block_button_text ??
    content.factsheetLink?.title ??
    (content?.factsheetVariant?.includes('price')
      ? props?.messages['getTheCostCalculation']
      : props?.messages['downloadManual'])
  );
}

export const getAnalyticsData = (
  content:
    | C2AFactsheetStoryblok
    | C2AMeetingStoryblok
    | C2ACommonStoryblok
    | C2APopupStoryblok,
  props: C2ABlockDetails,
  event_type: C2AAnalyticsClientProps['event_type'],
  block_element_click?: C2AAnalyticsClientProps['block_element_click'],
  investmentProgramStory?: ISbStoryData<InvestmentProgramStoryblok> | null,
  block_button_text?: string,
  blockType?: string,
  expertStory?: ISbStoryData<ExpertStoryblok> | null
): C2AAnalyticsClientProps => {
  const block_id = props.storyUID ?? '';
  const block_type = blockType ?? content.blockType;
  const block_name = getAnalyticsBlockName(
    content,
    investmentProgramStory,
    expertStory,
    block_type
  );
  const block_variant = getBlockVariant(content);
  const language = props.locale;
  const program_relation = content.programRelation ?? 'none';
  const program = investmentProgramStory?.name;
  const block_title_text = content.title ?? '';
  const block_button = getBlockButtonText(content, block_button_text, props);
  const element_click_url =
    content.factsheetLink?.url ?? content.link?.url ?? '';
  const page_url = '';

  return {
    block_id,
    block_type,
    block_name,
    block_variant,
    block_element_click,
    language,
    program_relation,
    program,
    block_title_text,
    block_button_text: block_button,
    event_type,
    element_click_url,
    page_url,
  };
};

export default getAnalyticsData;
